module.exports = __webpack_public_path__ + "static/media/YunChungCV.aa51388e.pdf";